module.exports = __webpack_public_path__ + "img/p94.d8e13da5.jpg";